import { z } from 'zod';

import type { CostHistoryStatus } from '../types/cost-estimate.types';

/** Decided statuses the History tab can filter on, in filter-menu order. */
export const HISTORY_STATUSES = [
  'APPROVED',
  'REJECTED',
  'EXPIRED',
  'CANCELLED',
] as const satisfies readonly CostHistoryStatus[];

/**
 * `/cost-approvals` URL state — tab, History status filter and 1-based History page — so
 * Back, reload and a shared link keep the view. Bad values fall back to the defaults
 * (Pending, all decisions, page 1) rather than throwing, so a hand-edited URL still opens.
 */
export const costApprovalsSearchSchema = z.object({
  tab: z.enum(['pending', 'history']).optional().catch(undefined),
  status: z.enum(HISTORY_STATUSES).optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
});

/** Parsed `/cost-approvals` search params. */
export type CostApprovalsSearch = z.infer<typeof costApprovalsSearchSchema>;

/**
 * `/cost-approvals/$workflowId` URL state: `estimateId` is the estimate a History row was
 * opened from. The page reads a run's LATEST estimate, so a different id means a newer one
 * replaced it and the page says so.
 */
export const costEstimateDetailSearchSchema = z.object({
  estimateId: z.string().optional().catch(undefined),
});
